import React from 'react';
import { Components } from './styled';
import { CellType } from '../../../../../api/types/others';

const CellTypePreview = ({ type }: { type: CellType }) => {
  const _renderPreview = () => {
    switch (type) {
      case 'largeCarousel':
        return (
          <>
            <Components.VerticalBar />
            <Components.FullHeightItem />
            <Components.VerticalBar2 />
          </>
        );
      case 'wideList':
      case 'listCard':
        return (
          <>
            <Components.WideItem />
            <Components.WideItem />
          </>
        );
      case 'defaultCarousel':
        return (
          <>
            <Components.DefaultCarouselItem />
            <Components.DefaultCarouselItem2 />
          </>
        );

      case 'authorCarousel':
        return (
          <Components.AuthorCarouselContainer>
            <Components.AuthorCarouselItem />
            <Components.AuthorCarouselItem2 />
            <Components.AuthorCarouselTitle />
          </Components.AuthorCarouselContainer>
        );
      case 'pillarCard':
        return (
          <>
            <Components.PillarCircle />
            <Components.PillarCircle />
            <Components.PillarCircle />
            <Components.PillarCircle />
            <Components.PillarCircle />
            <Components.InvisibleCircle />
          </>
        );
      case 'twoColumnsList':
      case 'simpleCard':
        return (
          <>
            <Components.ListColumnItem />
            <Components.ListColumnItem />
          </>
        );
      case 'playProgressCard':
        return (
          <>
            <Components.PlayProgressCardItem />
            <Components.PlayProgressCardItem />
          </>
        );
      case 'simpleCard2':
        return (
          <>
            <Components.SimpleCard2Item />
            <Components.SimpleCard2Item />
          </>
        );
    }
  };

  return <Components.Container type={type}>{_renderPreview()}</Components.Container>;
};

export default CellTypePreview;
